// @ts-nocheck
(function () {
  function getCartUrl() {
    if (typeof Theme !== 'undefined' && Theme.routes?.cart_url) return Theme.routes.cart_url;
    if (typeof routes !== 'undefined' && routes.cart_url) return routes.cart_url;
    if (window.Shopify?.routes?.root) return `${window.Shopify.routes.root}cart`;
    return '/cart';
  }

  function buildCompareAtMap(root = document) {
    const compareAtMap = {};

    root
      .querySelectorAll(
        '.cart-item[data-line-key], .cart-items__table-row[data-line-key], [data-cart-line][data-line-key], [data-cart-item][data-line-key]'
      )
      .forEach((el) => {
        const key = el.dataset.lineKey;
        if (!key) return;

        const compareAt = Number(el.dataset.compareAt);
        const normalizedCompareAt = Number.isFinite(compareAt) ? compareAt : 0;
        compareAtMap[key] = normalizedCompareAt;

        const variantId = el.dataset.variantId;
        if (variantId) {
          compareAtMap[`variant:${variantId}`] = normalizedCompareAt;
        }
      });

    return compareAtMap;
  }

  function resolveCompareAtForItem(item, compareAtMap) {
    const byKey = Number(compareAtMap[item.key]) || 0;
    if (byKey > 0) return byKey;

    if (item.variant_id) {
      const byVariant = Number(compareAtMap[`variant:${item.variant_id}`]) || 0;
      if (byVariant > 0) return byVariant;
    }

    return 0;
  }

  function calculateCartSavings(cart, compareAtMap) {
    if (!cart?.items?.length) return 0;

    let compareAtSavings = 0;
    let lineDiscountSavings = 0;

    cart.items.forEach((item) => {
      const compareAt = resolveCompareAtForItem(item, compareAtMap);
      const unitPrice = Number(item.original_price) || Number(item.price) || 0;
      const quantity = Number(item.quantity) || 0;
      const originalLinePrice = Number(item.original_line_price) || 0;
      const finalLinePrice = Number(item.final_line_price) || 0;

      const compareSaving = compareAt > unitPrice ? (compareAt - unitPrice) * quantity : 0;

      if (Number.isFinite(compareSaving) && compareSaving > 0) {
        compareAtSavings += compareSaving;
      }

      const lineDiscount = Math.max(0, originalLinePrice - finalLinePrice);
      if (Number.isFinite(lineDiscount)) {
        lineDiscountSavings += lineDiscount;
      }
    });

    const cartTotalDiscount = Math.max(0, Number(cart.total_discount) || 0);
    const discountSavings = Math.max(cartTotalDiscount, lineDiscountSavings);
    const totalSavings = compareAtSavings + discountSavings;

    return Number.isFinite(totalSavings) ? Math.max(0, Math.round(totalSavings)) : 0;
  }

  function readSsrSavingsCents() {
    let maxSsrCents = 0;

    document.querySelectorAll('[data-cart-savings-container]').forEach((container) => {
      const cents = Number(container.getAttribute('data-cart-savings-cents'));
      if (Number.isFinite(cents) && cents > maxSsrCents) {
        maxSsrCents = cents;
      }
    });

    return maxSsrCents;
  }

  function formatCartSavingsCents(cents) {
    const amount = Math.max(0, Math.round(Number(cents) || 0));

    if (typeof window.formatMoney === 'function' && window.money_format) {
      return window.formatMoney(amount, window.money_format);
    }

    if (typeof window.Shopify?.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount);
    }

    return (amount / 100).toFixed(2);
  }

  function formatCartSavingsAmount(cents) {
    const roundedCents = Math.round((Number(cents) || 0) / 100) * 100;
    let formatted = formatCartSavingsCents(roundedCents);

    if (typeof formatted === 'string') {
      formatted = formatted.replace(/\.00$/, '').trim();
    }

    return formatted;
  }

  function renderCartSavingsDisplay(savingsCents) {
    let savings = Math.max(0, Math.round(Number(savingsCents) || 0));

    if (!savings) {
      const ssrCents = readSsrSavingsCents();
      if (ssrCents > 0) savings = ssrCents;
    }

    const formatted = formatCartSavingsAmount(savings);

    document.querySelectorAll('[data-cart-savings]').forEach((el) => {
      if (formatted) {
        el.textContent = formatted;
      }
    });

    document.querySelectorAll('[data-cart-savings-container]').forEach((container) => {
      container.setAttribute('data-cart-savings-cents', String(savings));

      if (savings > 0 && formatted) {
        container.removeAttribute('hidden');
        container.style.display = '';
      } else {
        container.setAttribute('hidden', '');
        container.style.display = 'none';
      }
    });
  }

  function getCartFromEvent(event) {
    return event?.detail?.cart || event?.detail?.cartData || event?.detail?.resource || event?.cartData;
  }

  async function updateCartSavings(cart) {
    const compareAtMap = buildCompareAtMap();
    let cartData = cart;

    if (!cartData) {
      try {
        const res = await fetch(`${getCartUrl()}.js`);
        if (!res.ok) return;
        cartData = await res.json();
      } catch (e) {
        console.error('updateCartSavings:', e);
        return;
      }
    }

    renderCartSavingsDisplay(calculateCartSavings(cartData, compareAtMap));
  }

  function debounce(fn, wait) {
    let timeoutId;

    return function debounced(...args) {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => fn.apply(this, args), wait);
    };
  }

  const scheduleCartSavingsUpdate = debounce((cart) => {
    updateCartSavings(cart);
  }, 50);

  function bindCartSavingsLifecycle() {
    updateCartSavings();

    document.addEventListener('cart:updated', (event) => {
      scheduleCartSavingsUpdate(getCartFromEvent(event));
    });

    document.addEventListener('cart:update', (event) => {
      scheduleCartSavingsUpdate(getCartFromEvent(event));
    });

    document.addEventListener('cart:change', (event) => {
      scheduleCartSavingsUpdate(getCartFromEvent(event));
    });

    document.addEventListener('cart:refresh', scheduleCartSavingsUpdate);
    document.addEventListener('discount:update', scheduleCartSavingsUpdate);
    document.addEventListener('cart-drawer:open', scheduleCartSavingsUpdate);
    document.addEventListener('cart-drawer:updated', scheduleCartSavingsUpdate);

    document.addEventListener('shopify:section:morphed', () => {
      scheduleCartSavingsUpdate();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        scheduleCartSavingsUpdate(event?.cartData);
      });
    }

    const observerRoot =
      document.querySelector('cart-drawer-component') ||
      document.querySelector('[data-cart-drawer]') ||
      document.querySelector('.cart-page-wrapper') ||
      document.body;
    if (observerRoot) {
      const observer = new MutationObserver((mutations) => {
        const shouldUpdate = mutations.some((mutation) => {
          if (mutation.type !== 'childList') return false;

          return Array.from(mutation.addedNodes).some((node) => {
            if (!(node instanceof Element)) return false;
            return (
              node.matches?.(
                '[data-cart-savings-container], .cart-item, .cart-items__table-row, [data-cart-line], [data-cart-item]'
              ) ||
              node.querySelector?.(
                '[data-cart-savings-container], .cart-item, .cart-items__table-row, [data-cart-line], [data-cart-item]'
              )
            );
          });
        });

        if (shouldUpdate) scheduleCartSavingsUpdate();
      });

      observer.observe(observerRoot, { childList: true, subtree: true });
    }
  }

  window.buildCompareAtMap = buildCompareAtMap;
  window.calculateCartSavings = calculateCartSavings;
  window.updateCartSavings = updateCartSavings;
  window.scheduleCartSavingsUpdate = scheduleCartSavingsUpdate;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCartSavingsLifecycle, { once: true });
  } else {
    bindCartSavingsLifecycle();
  }
})();
